import { gql } from '@apollo/client';

export const SEO_LANG_STATUSES_ITEM_FRAGMENT = gql`
  fragment SeoLangStatusesItemFragment on SeoLangStatusesItem {
    status
    date
  }
`;

export const SEO_LANG_STATUSES_FRAGMENT = gql`
  fragment SeoLangStatusesFragment on SeoLangStatuses {
    locale
    description {
      ...SeoLangStatusesItemFragment
    }
  }
`;
